import { useEffect, useState } from "react";
import usePointsConverter from "./usePointsConverter";
import { set } from "react-hook-form";

export default function useMapConversion(map, canvasSize) {
  const { percentToPixel } = usePointsConverter();
  const [polygons, setPolygons] = useState(null);
  const [route, setRoute] = useState(null);
  const [addons, setAddons] = useState(null);
  const [markers, setMarkers] = useState(null);

  useEffect(() => {
    if (!map || !canvasSize) {
      setPolygons(null);
      setRoute(null);
      setAddons(null);
      setMarkers(null);
      return;
    }

    // polygons
    if (Array.isArray(map.polygons) && map.polygons.length > 0) {
      const polys = map.polygons.map((poly) => {
        try {
          const arrPoint = JSON.parse(poly.point);
          return { ...poly, points: percentToPixel(arrPoint, canvasSize.w, canvasSize.h) };
        } catch (e) {
          return poly;
        }
      });
      setPolygons(polys);
    } else {
      setPolygons(null);
    }

    // route
    if (map.route !== null && map.route !== undefined && map.route.point) {
      try {
        const arr = JSON.parse(map.route.point);
        setRoute({ id: map.route.id, point: percentToPixel(arr, canvasSize.w, canvasSize.h) });
      } catch (e) {
        setRoute(null);
      }
    } else {
      setRoute(null);
    }

    // addons
    if (Array.isArray(map.addons) && map.addons.length > 0) {
      const adds = map.addons.map((addon) => {
        try {
          const arrPoint = JSON.parse(addon.point);
          return { ...addon, point: percentToPixel(arrPoint, canvasSize.w, canvasSize.h) };
        } catch (e) {
          return addon;
        }
      });
      setAddons(adds);
    } else {
      setAddons(null);
    }

    // markers
    if (Array.isArray(map.markers) && map.markers.length > 0) {
      const mark = map.markers.map((marker) => {
        try {
          const arrPoint = JSON.parse(marker.point);
          return { ...marker, point: percentToPixel(arrPoint, canvasSize.w, canvasSize.h) };
        } catch (e) {
          return marker;
        }
      });
      setMarkers(mark);
    } else {
      setMarkers(null);
    }
  }, [map, canvasSize, percentToPixel]);

  return { polygons, route, addons, markers, setPolygons, setRoute, setAddons, setMarkers };
}